import { render, staticRenderFns } from "./ViewProject.vue?vue&type=template&id=7a992f52&scoped=true&"
import script from "./ViewProject.vue?vue&type=script&lang=js&"
export * from "./ViewProject.vue?vue&type=script&lang=js&"
import style0 from "./ViewProject.vue?vue&type=style&index=0&id=7a992f52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a992f52",
  null
  
)

export default component.exports